import styled from '@emotion/styled';

const Header = styled('header')({
  alignItems: 'center',
  display: 'flex',
  textAlign: 'left',
});

export default Header;
